import { createContext } from 'react'

export type CueLiveContentContextType = true

const CueLiveContentContext = createContext<
  CueLiveContentContextType | undefined
>(undefined)

export default CueLiveContentContext
